import { render, staticRenderFns } from "./Y67TPrimaryDataTable.vue?vue&type=template&id=26820dcd&scoped=true&"
import script from "./Y67TPrimaryDataTable.vue?vue&type=script&lang=js&"
export * from "./Y67TPrimaryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./Y67TPrimaryDataTable.vue?vue&type=style&index=0&id=26820dcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26820dcd",
  null
  
)

export default component.exports